import { WidgetSubtab } from './WidgetSubtab'
import { connect } from 'react-redux'

const mapStateToProps = (state: { activeBot }) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(WidgetSubtab)
